export const SENTIMENT_TYPES = {
    1: "Позитивная",
    2: "Нейтральная",
    3: "Негативная",
    16: "Не определена",
  },
  COLORS = ["#01b8aa", "#fbc02d", "#fd625e", "#0975da", "#8e24aa", "#72a62e"];
